import type { PreviewOrderQuoteOfferFeasibilityInput } from '@codezo/graphql';
import type { Pricing } from './types';

/** Build the feasibility-preview input for one pricing tier, or `null` to stay
 * idle. We always preview (like the wizard) — with no deadline the verdict is a
 * neutral "Arrives {window}" pill; with one it's the colored meet/miss verdict. */
export function buildTierFeasibilityInput(
	pricing: Pricing | undefined,
	deadline: string | null,
	acceptDeadline: string | null
): PreviewOrderQuoteOfferFeasibilityInput | null {
	if (!pricing) return null;
	return {
		minProductionDays: pricing.minProductionDays ?? null,
		maxProductionDays: pricing.maxProductionDays ?? null,
		deadline: deadline ?? undefined,
		acceptDeadline: acceptDeadline ?? undefined,
		// A method priced before its lead time was settled has no arrival to
		// project, so it is left out rather than previewed as zero days.
		//
		// Splits are left out too, and for a different reason: the result comes
		// back keyed by shipping method, and a split's method is DERIVED from its
		// first leg. Previewing one puts a second EXPRESS entry in the response
		// that silently overwrites the real Express row in that map — so the plain
		// method would show the split's dates. A split's arrival is already on the
		// saved row and on each of its parts; it needs no preview.
		deliveries: (pricing.deliveries ?? []).flatMap((d) =>
			!d.isSplit && d.deliveryDaysMin != null && d.deliveryDaysMax != null
				? [
						{
							shippingMethod: d.shippingMethod,
							deliveryDaysMin: d.deliveryDaysMin,
							deliveryDaysMax: d.deliveryDaysMax,
						},
					]
				: []
		),
	};
}
